import React from "react"

export const EinfacheVeroeffentlichung = ({ size = 1 }) => {
  return (
    <svg
      width={69 * size}
      height={83 * size}
      viewBox="0 0 69 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.287 15.382h12.846L57.979 0v55.324L21.133 42.218H8.287V15.382z"
        fill="#E5EDF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.264 52.67l33.764 9.822V13.67l-33.764 13.4v25.6z"
        fill="#000"
      />
      <path
        d="M25.849 55.694v25.51H14.342V41.067"
        stroke="#034055"
        strokeWidth={3.5}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 52.67h12.263v-25H2v25zm12.263.142l33.764 9.858v-49L14.263 27.119v25.693z"
        fill="#FFD62E"
      />
      <path
        d="M2 52.67H.5v1.5H2v-1.5zm12.263 0v1.5h1.5v-1.5h-1.5zm0-25h1.5v-1.5h-1.5v1.5zM2 27.67v-1.5H.5v1.5H2zm12.263 25.142h-1.5v1.125l1.08.315.42-1.44zm33.764 9.858l-.42 1.44 1.92.56v-2h-1.5zm0-49h1.5v-2.212l-2.055.818.555 1.394zM14.263 27.119l-.555-1.394-.945.377v1.017h1.5zM2 54.169h12.263v-3H2v3zm13.763-1.5v-25h-3v25h3zm-1.5-26.5H2v3h12.263v-3zM.5 27.67v25h3v-25h-3zm13.342 26.583l33.765 9.858.84-2.88-33.764-9.858-.84 2.88zm35.685 8.418v-49h-3v49h3zm-2.055-50.394l-33.764 13.45 1.11 2.786 33.764-13.449-1.11-2.787zM12.762 27.12v25.693h3V27.12h-3z"
        fill="#FFD62E"
      />
      <path
        d="M56.658 49.862l10 6.712M56.658 26.382l10-6.712M57.658 37.81h11"
        stroke="#034055"
        strokeWidth={3.5}
      />
    </svg>
  )
}
